import ATable, { ATableHeader } from '../../../../organisms/ATable';
import { OutboxSummary } from '../../../../../services/eventingApi';
import { formatDateTime } from '../shared/format';
import { EmptyState, Section, classNames } from '../shared/ui';

const HEADER_CLASS = 'border-b px-2 text-left';

const HEADERS: ATableHeader[] = [
  { id: 'service', title: 'Serviço', canSort: false, cssClass: HEADER_CLASS },
  { id: 'pending', title: 'Pendentes', canSort: false, cssClass: HEADER_CLASS },
  { id: 'oldest', title: 'Mais antiga', canSort: false, cssClass: HEADER_CLASS },
  { id: 'attempts', title: 'Tentativas (máx.)', canSort: false, cssClass: HEADER_CLASS },
];

const ProducersCard = ({ outbox }: { outbox: OutboxSummary[] }) => (
  <Section title="Produtores (outbox)" subtitle="Linhas gravadas pelos serviços e ainda não publicadas pelo varredor">
    {outbox.length === 0 ? (
      <EmptyState text="Outbox vazio: tudo publicado." />
    ) : (
      <ATable headers={HEADERS}>
        {outbox.map((row) => (
          <tr key={row.sourceService} className="border-t border-gray-100 dark:border-gray-700 dark:text-gray-100">
            <td className="px-2 py-2 font-mono">{row.sourceService}</td>
            <td className="px-2 py-2">{row.pending}</td>
            <td className="px-2 py-2">{formatDateTime(row.oldestOccurredAt)}</td>
            <td className={classNames('px-2 py-2', { 'font-semibold text-red-600 dark:text-red-400': row.maxAttempts >= 3 })}>{row.maxAttempts}</td>
          </tr>
        ))}
      </ATable>
    )}
  </Section>
);

export default ProducersCard;
